
import { faFacebook, faTwitter, faInstagram, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

export const aboutUser = {

    fullName: "Wejdi Gharbi",

    workPosition: "FullStack Developer || SpringBoot & ReactJS || PSM® & PSPO® Certified ... ",

    socialLinks: [

        {
            id: 1,
            link: "https://www.linkedin.com/in/wejdigharbi/",
            icon: faLinkedin,
            className:"linkedin"
        },
        {
            id: 2,
            link: "https://github.com/Wejdi-Gh",
            icon: faGithub,
            className:"git"
        },
        {
            id: 3,
            link: "",
            icon: faFacebook,
            className:"fb"
        },
        {
            id: 4,
            link: "https://twitter.com/Wejdi_Gh",
            icon: faTwitter,
            className:"twitter"
        },

        {
            id: 5,
            link: "",
            icon: faInstagram,
            className:"insta"
        }

    ]



}